import {find, transform} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Accordion, AccordionDetails, AccordionTitle, CopyText, Icon, ParticipantIcon, TextChatMessageList} from 'components';
import {SessionHistory} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';
import {ParticipantRole} from 'types';
import {sessionUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.TEXT_CHAT_HISTORY_SIDEBAR;

type Props = {
    sessionHistory: SessionHistory;
    localUserEid: number;
    className?: string;
}

export const TextChatHistoryAccordion: React.FC<Props> = ({sessionHistory, localUserEid, className}) => {
    const {t} = useTranslation();

    const messages = useMemo(() => sessionUtils.getSessionHistoryTextChatMessages(sessionHistory), [sessionHistory]);

    const localParticipant = useMemo(() =>
        find(sessionHistory.participants, (p) => p.data?.eid === localUserEid), [sessionHistory, localUserEid]);
    const userParticipantIds = useMemo(() => sessionUtils.getUserParticipantIdGroups(sessionHistory), [sessionHistory]);

    return (
        <Accordion className={className} shadow={false}>
            <AccordionTitle iconPlacement='right'>
                {transform(sessionHistory.participants, (acc, participant) => {
                    if ([ParticipantRole.Agent, ParticipantRole.Assistant].includes(participant.role)) {
                        acc.push(
                            <div key={participant.id} className='tw-flex'>
                                <ParticipantIcon role={participant.role} className='tw-mr-4' />
                                {sessionUtils.getParticipantName(participant?.data, t(T_KEYS.NO_AGENT))}
                            </div>
                        );
                    }
                }, [])}

            </AccordionTitle>
            <AccordionDetails>
                <div className='tw-flex tw-items-center tw-font-bold'>
                    <Icon name='id' className='tw-mr-1' />
                    <CopyText text={sessionHistory.sessionId} labelPlacement='left' />
                </div>
                <div className='vs-session-text-chat tw-pr-4 tw-mt-4 tw-max-h-96 tw-overflow-scroll'>
                    <TextChatMessageList
                        messages={messages}
                        participants={sessionHistory.participants}
                        localParticipantId={localParticipant?.id}
                        userParticipantIds={userParticipantIds}
                        downloadFile={() => null}
                        messagesEndRef={null}
                        downloadingFiles={[]}
                        typingRemoteParticipantIds={[]}
                        downloadFileDisabled
                    />
                </div>
            </AccordionDetails>
        </Accordion>
    );
};